export class BaseEndpoints {
  public static readonly V1 = '/v1/';
  public static readonly INIT_DATADOG_CONFIG = BaseEndpoints.V1 + 'datadog/init';
}
